import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Card, CardBody, Col, Nav, NavItem, NavLink, TabContent, TabPane,
} from 'reactstrap';
import classnames from 'classnames';
import { Field, reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import ECO from './ECO/ECO';
import Stress from './Stress/Stress';
import Test from './Test/Test';
import EKG from './EKG/EKG';
import Holter from './Holter/Holter';
import Map from './Map/Map';
import Results from './Results/Results';
import Laboratorio from './Laboratorio/Laboratorio';

class MedicalProcedures extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: '1',
      professional: [],
      patient: [],
      clinic: [],
      loadMedicalProcedure: false
    };
  }

  toggle = (tab) => {
    const { activeTab } = this.state;
    if (activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  };
  /*
        componentDidMount() {
          this.setState({ loadMedicalProcedure: true }, ()=>{
            this.props.loadMedicalProcedures().then((load) => {
              this.setState({ loadMedicalProcedure: load },()=>{
                  console.log("cargar terminada !!");
              });
            }).catch((error)=>{
              console.log(error)
            });
          })    
        }*/


  componentDidMount() {
    this.getProfessional();
    this.loadDataPatient();
    this.loadDataProfile();
  }

  getProfessional = async () => {

    const dataSend = { id_historia: parseInt(this.props.id_historia), id_admision: parseInt(this.props.id_admision) }

    await fetch(process.env.REACT_APP_PUBLIC_URL + 'evento/consultar', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + sessionStorage.getItem('token'),
      },
      body: JSON.stringify(dataSend)
    })
      .then(response => {
        return response.json();
      })
      .then(data => {
        //console.log(data);
        this.setState({ professional: data.contenido.profesional });

      })
      .catch((error) => {
        alert(error);
        console.error('Error:', error);
      });
  }

  loadDataPatient = async () => {
    const dataSend = { num_documento: this.props.num_documento };

    await fetch(process.env.REACT_APP_PUBLIC_URL + 'paciente/consultar', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + sessionStorage.getItem('token'),
      },
      body: JSON.stringify(dataSend)
    })
      .then(response => {
        return response.json();
      })
      .then(data => {
        //console.log(data);
        if (data.existe) {
          this.setState({ patient: data.contenido[0] });
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }

  loadDataProfile = async () => {

    await fetch(process.env.REACT_APP_PUBLIC_URL + 'clinica/listar', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + sessionStorage.getItem('token'),
      }
    })
      .then(response => {
        return response.json();
      })
      .then(data => {
        console.log(data);
        this.setState({ clinic: data[0] })
      })
      .catch((error) => {
        console.error('Error:', error);

      })
  }

  render() {

    const { t } = this.props;
    const { activeTab } = this.state;

    return (
      <Col>
        <Card>
          <CardBody>
            <div className="tabs tabs--bordered-top">
              <div className="tabs__wrap">
                <Nav tabs>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === '1' })}
                      onClick={() => {
                        this.toggle('1');
                      }}
                    >
                      Resultados
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === '2' })}
                      onClick={() => {
                        this.toggle('2');
                      }}
                    >
                      ECO
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === '3' })}
                      onClick={() => {
                        this.toggle('3');
                      }}
                    >
                      Estres
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === '4' })}
                      onClick={() => {
                        this.toggle('4');
                      }}
                    >
                      Prueba
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === '5' })}
                      onClick={() => {
                        this.toggle('5');
                      }}
                    >
                      EKG
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === '6' })}
                      onClick={() => {
                        this.toggle('6');
                      }}
                    >
                      Holter
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === '7' })}
                      onClick={() => {
                        this.toggle('7');
                      }}
                    >
                      Mapa
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === '8' })}
                      onClick={() => {
                        this.toggle('8');
                      }}
                    >
                      Laboratorio
                    </NavLink>
                  </NavItem>
                </Nav>
                <TabContent activeTab={activeTab}>
                  <TabPane tabId="1">
                    <Results
                      medicalProcedures={this.props.MedicalProcedures}
                    />
                  </TabPane>
                  <TabPane tabId="2">
                    <ECO
                      num_documento={this.props.num_documento}
                      cie={this.props.MedicalProcedures.ECO.cie}
                      addedMedicaments={this.props.MedicalProcedures.ECO.addedMedicaments}
                      dataProcedure={this.props.MedicalProcedures.ECO}
                      professional={this.state.professional}
                      medicament={this.props.MedicalProcedures.ECO.medicament}
                      handlerMedicalProcedures={this.props.handlerMedicalProcedures}
                      handlerMedications={this.props.handlerMedications}
                      selectMedicament={this.props.selectMedicament}
                      addMedicament={this.props.addMedicament}
                      removeMedicament={this.props.removeMedicament}
                      searchMedications={this.props.searchMedications}
                    />
                  </TabPane>
                  <TabPane tabId="3">
                    <Stress
                      num_documento={this.props.num_documento}
                      cie={this.props.MedicalProcedures.Stress.cie}
                      professional={this.state.professional}
                      dataProcedure={this.props.MedicalProcedures.Stress}
                      medicament={this.props.MedicalProcedures.Stress.medicament}
                      handlerMedicalProcedures={this.props.handlerMedicalProcedures}
                      handlerMedications={this.props.handlerMedications}
                      selectMedicament={this.props.selectMedicament}
                      addMedicament={this.props.addMedicament}
                      removeMedicament={this.props.removeMedicament}
                      searchMedications={this.props.searchMedications}
                    />
                  </TabPane>
                  <TabPane tabId="4">
                    <Test
                      num_documento={this.props.num_documento}
                      cie={this.props.MedicalProcedures.Test.cie}
                      professional={this.state.professional}
                      dataProcedure={this.props.MedicalProcedures.Test}
                      medicament={this.props.MedicalProcedures.Test.medicament}
                      handlerMedicalProcedures={this.props.handlerMedicalProcedures}
                      handlerMedications={this.props.handlerMedications}
                      selectMedicament={this.props.selectMedicament}
                      addMedicament={this.props.addMedicament}
                      removeMedicament={this.props.removeMedicament}
                      searchMedications={this.props.searchMedications}
                    />
                  </TabPane>
                  <TabPane tabId="5">
                    <EKG
                      num_documento={this.props.num_documento}
                      cie={this.props.MedicalProcedures.EKG.cie}
                      professional={this.state.professional}
                      dataProcedure={this.props.MedicalProcedures.EKG}
                      addedMedicaments={this.props.MedicalProcedures.EKG.addedMedicaments}
                      medicament={this.props.MedicalProcedures.EKG.medicament}
                      handlerMedicalProcedures={this.props.handlerMedicalProcedures}
                      handlerMedications={this.props.handlerMedications}
                      selectMedicament={this.props.selectMedicament}
                      addMedicament={this.props.addMedicament}
                      removeMedicament={this.props.removeMedicament}
                      searchMedications={this.props.searchMedications}
                    />
                  </TabPane>
                  <TabPane tabId="6">
                    <Holter
                      num_documento={this.props.num_documento}
                      cie={this.props.MedicalProcedures.Holter.cie}
                      professional={this.state.professional}
                      dataProcedure={this.props.MedicalProcedures.Holter}
                      medicament={this.props.MedicalProcedures.Holter.medicament}
                      handlerMedicalProcedures={this.props.handlerMedicalProcedures}
                      handlerMedications={this.props.handlerMedications}
                      selectMedicament={this.props.selectMedicament}
                      addMedicament={this.props.addMedicament}
                      removeMedicament={this.props.removeMedicament}
                      searchMedications={this.props.searchMedications}
                    />
                  </TabPane>
                  <TabPane tabId="7">
                    <Map
                      num_documento={this.props.num_documento}
                      cie={this.props.MedicalProcedures.Map.cie}
                      professional={this.state.professional}
                      dataProcedure={this.props.MedicalProcedures.Map}
                      medicament={this.props.MedicalProcedures.Map.medicament}
                      handlerMedicalProcedures={this.props.handlerMedicalProcedures}
                      handlerMedications={this.props.handlerMedications}
                      selectMedicament={this.props.selectMedicament}
                      addMedicament={this.props.addMedicament}
                      removeMedicament={this.props.removeMedicament}
                      searchMedications={this.props.searchMedications}
                    />
                  </TabPane>
                  <TabPane tabId="8">
                    <Laboratorio
                      examResults={this.props.examResults}
                      patient={this.state.patient}
                      clinic={this.state.clinic}
                      professional={this.state.professional} />
                  </TabPane>
                </TabContent>
              </div>
            </div>
          </CardBody>
        </Card>
      </Col>);
  }
}

export default reduxForm({
  form: `medical-procedures-form`, // a unique identifier for this form
})(withTranslation('common')(MedicalProcedures));